<template>
  <v-layout row>
    <div class="btn">
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="red"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="black" flat @click="snackbar = false"> Close </v-btn>
      </v-snackbar>
    </div>
    <v-flex xs12>
      <v-card-text class="pt-0">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout wrap v-if="indexData.agent_groups.length>0">
            <v-flex xs12 sm6 md6>
              <v-select
                v-model="projectAgentData.agent_group"
                :rules="agent_group"
                :items="indexData.agent_groups"
                :item-text="textItem"
                item-value="id"
                box
                label="Select Agent Group"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout wrap v-else>
            Agent group not available. Please create a group now.
          </v-layout>
          <v-layout wrap v-if="projectAgentData.agent_group">
            <v-radio-group v-model="projectAgentData.agentTaskAssignmentMethod">
              <v-radio label="Unlimited Response" value="1"></v-radio>
              <v-radio label="Maximum Response" value="2"></v-radio>
              <v-radio
                label="Individual Response Per Agent"
                value="3"
              ></v-radio>
            </v-radio-group>
          </v-layout>
          <v-layout wrap v-if="projectAgentData.agentTaskAssignmentMethod == 2">
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="projectAgentData.numberOfMaximumResponsePerAgent"
                box
                label="Number Maximum Response Per Agent"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
        
          <define-task-to-agent :agent_group_id="projectAgentData.agent_group"  v-if="projectAgentData.agentTaskAssignmentMethod == 3" class="" />
       
      </v-card-text>
      <v-divider v-if="projectAgentData.agentTaskAssignmentMethod != 3"></v-divider>
      <v-card-actions v-if="projectAgentData.agentTaskAssignmentMethod != 3">
        <v-spacer></v-spacer>
        <v-btn :disabled="!hasAgentGroup" class="button" flat @click="submit"
          >Save & next</v-btn
        >
      </v-card-actions>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import DefineTaskToAgent from "./DefineTaskToAgent";
export default {
  components: {
    DefineTaskToAgent,
  },
  data: () => ({
    apiUrl: "project.agent-info",
    dialog: false,
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    projectAgentData: {
      agent_group: null,
      project_id: null,
      agentTaskAssignmentMethod: null,
      numberOfMaximumResponsePerAgent: null,
    },
    defaultItem: {
      project_id: null,
      agentTaskAssignmentMethod: null,
      numberOfMaximumResponsePerAgent: null,
    },
    valid: true,
    agent_group: [(v) => !!v || "agent_group is required"],
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    dasher_category_check: function () {
      // console.log(this.dasher_category);
      return true;
    },
    hasAgentGroup() {
      if (this.projectAgentData.agent_group) {
        return true;
      } else {
        return false;
      }
    },

    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  watch: {},

  created() {
    this.initialize();
    // this.editedData()
  },
  methods: {
    initialize() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.projectAgentData.project_id = project_id;
      this.$store.dispatch("indexData", [this.apiUrl, project_id]);
    },

    textItem: function (event) {
      return event.name + " : " + event.code + "(" + event.numberOfAgent + ")";
    },
    close() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    getProjectType() {
      if (this.indexData.project_data) {
        if (this.indexData.project_data.project_type_id) {
          return this.indexData.project_data.project_type_id;
        }
      }
      return false;
    },

    submit() {
      // console.log(this.projectAgentData);
      if (this.$refs.form.validate()) {
        if (!this.projectAgentData.agent_group) {
          alert("please select a group");
        } else {
          this.projectAgentData.project_id = JSON.parse(
            localStorage.getItem("project_id")
          );
          this.$store.dispatch("storeOrUpdateProjectAgentAssignment", [
            "assign.agent.group.to-project",
            this.projectAgentData,
          ]);
        }
        this.snackbar = true;
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 30px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
.no-upercase {
  text-transform: unset !important;
}
</style>
